import { routing } from './confirmation-payement.routing';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfirmationPayementComponent } from './confirmation-payement.component';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        routing
    ],
    declarations: [
        ConfirmationPayementComponent
    ],
    exports: [
        ConfirmationPayementComponent
    ]
})

export class ConfirmationPayementModule {

}
